/**
 * Parse Query
 * @author Stefano Azzolini <stefano.azzolini@caffeinalab.com>
 */
function parse_query( s ) {
	var j = {},
		res = s.split( /&/gm ).map( function ( e ) {
			var o = e.split( /=/ ),
				pt = j;
			o[0].replace( /^(\w+)\[([^&]+)\]/, '$1][$2' ).split( /\]\[/ ).map( function ( e, i, a ) {
				pt = (
					pt[e] = pt[e] || (
						i == a.length - 1 ? decodeURIComponent( o[1].replace( /\+/, ' ' ) ) : {}
					)
				);
			} );
		} );
	return j;
}

(
	function ( $ ) {

		$( '.esrb-form .all' ).on( 'change', function ( event ) {
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );
			var $all = $fieldgroup.find( 'input[type="checkbox"]:not(.all)' );
			$all.prop( 'checked', false );
		} );

		$( '.esrb-form input[type="checkbox"]:not(.all)' ).on( 'change', function ( event ) {
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );
			var $all = $fieldgroup.find( 'input[type="checkbox"].all' );

			var $checked = $fieldgroup.find( 'input[type="checkbox"]:checked' );
			$all.prop( 'checked', $checked.length == 0 );

		} );

		$( '.esrb-form .group h4' ).on( 'click', function ( event ) {
			var $checkboxes = $( this ).closest( '.group' ).find( 'input[type="checkbox"]' );
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );

			var $all = $fieldgroup.find( 'input[type="checkbox"].all' );

			var checked = false;

			$checkboxes.each( function ( index, el ) {
				if ( $( el ).prop( 'checked' ) ) {
					checked = true;
				} else {
					checked = false;
					return;
				}
				;
			} );

			if ( !checked ) {
				$checkboxes.prop( 'checked', true );
			} else {
				$checkboxes.prop( 'checked', false );
			}

			var $checked = $fieldgroup.find( 'input[type="checkbox"]:checked' );
			$all.prop( 'checked', $checked.length == 0 );
		} );


		var $searchResultsPlaceholder = $( '.search-results #results' );

		// Initial search on page load
		if ( $searchResultsPlaceholder.html() == '' ) {

			var params = parse_query( window.location.search );

			updateSearchAjax( params.pg );

		}

		var searchTimer;
		var xhr = null;
		var cachedResults = {};

		$( '.filter input[type=checkbox]' ).change( function ( event ) {
			clearTimeout( searchTimer );
			if ( xhr ) {
				xhr.abort();
			}

			if ( $( window ).width() > 767 ) {
				searchTimer = setTimeout( updateSearchAjax, 2000 );
			}
		} );

		// $( ".filter .esrb-autocomplete" ).on( "autocompleteselect", function( event, ui ) {
		// 	clearTimeout( searchTimer );
		//
		// 	if ( $(window).width() > 767 ) {
		// 		searchTimer = setTimeout( updateSearchAjax, 500 );
		// 	}
		// } );


		// Selects should trigger faster
		$( '.filter select' ).change( function ( event ) {
			clearTimeout( searchTimer );
			if ( xhr ) {
				xhr.abort();
			}

			if ( $( window ).width() > 767 ) {
				searchTimer = setTimeout( updateSearchAjax, 500 );
			}
		} );


		$( '.filter .button' ).on( 'click', function ( event ) {
			event.preventDefault();
			if ( $( window ).width() < 768 ) {
				$( '.filter .refine' ).slideToggle();
			}
			updateSearchAjax();
		} );
		$( '.filter' ).on( 'submit', function ( event ) {
			event.preventDefault();
			if ( $( window ).width() < 768 ) {
				$( '.filter .refine' ).slideToggle();
			}
			updateSearchAjax();
		} );

		$( '.filter h2' ).on( 'click', function ( event ) {
			if ( $( window ).width() < 768 ) {
				event.preventDefault();
				$( '.filter .refine' ).slideToggle();
			}
		} );

		function updateSearchAjax( page = 1 ) {
			var args = {};
			$( 'html, body' ).stop().animate( {scrollTop: 0}, 500, 'swing' );

			args.searchKeyword = $( '#searchKeyword' ).val();
			args.searchType = $( '#searchType' ).val();
			if ( $( '#timeFrame' ).length ) {
				args.timeFrame = $( '#timeFrame' ).val();
			}

			args.pg = page;
			args.platform = [];
			args.rating = [];
			args.descriptor = [];
			args.ielement = [];

			$( '.filter .platforms input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.platform.push( $( this ).val() );
			} );
			$( '.filter .ratings input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.rating.push( $( this ).val() );
			} );
			$( '.filter .descriptors input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.descriptor.push( $( this ).val() );
			} );

			$( '.filter .ielements input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.ielement.push( $( this ).val() );
			} );

			if ( xhr ) {
				xhr.abort();
			}
			const stringifiedArgs = queryString.stringify( args );

			$searchResultsPlaceholder.fadeOut( 300, function () {

				$searchResultsPlaceholder.html( '<div class="spinner-cont"><div class="loading-spinner"></div></div>' ).fadeIn();

				if ( cachedResults[stringifiedArgs] ) {

					ajaxPutUpdatedContent( cachedResults[stringifiedArgs] );

				} else {

					xhr = $.ajax( {
						url: ESRB.ajaxurl,
						type: 'post',
						dataType: 'json',
						data: {
							action: 'search_rating',
							args: args
						},
					} ).done( function ( response ) {
						console.info( (
							response.json_body || ''
						) );

						cachedResults[stringifiedArgs] = response;
						/* double cache because URL params may change after being received from PHP back via ajax */
						cachedResults[queryString.stringify( response.args )] = response;
						ajaxPutUpdatedContent( response );
					} );
				}


			} );

		}

		function ajaxPutUpdatedContent( response ) {

			$searchResultsPlaceholder.html( response.html_results );
			$searchResultsPlaceholder.append( response.paging );
			$( '.search-results .key' ).html( response.args.searchKeyword );

			var total = response.total ? '(total ' + response.total + ' found)' : '';
			$( '.search-results .total' ).html( total );

			setUrlState( response.args );
		}


		function setUrlState( args ) {
			var query = queryString.stringify( args, {sort: false, arrayFormat: 'bracket'} );

			if ( history.pushState ) {
				var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + query;
				window.history.pushState( {path: newurl}, '', newurl );
			}
		}

		$( '.search-results #results' ).on( 'click', '.paginate a', function ( event ) {
			event.preventDefault();
			var hash = $( this ).attr( 'href' ).split( '#' )[1] || 0;
			if ( !hash ) {
				hash = 1;
			}
			updateSearchAjax( hash );
			$( 'html, body' ).stop().animate( {scrollTop: 0}, 500, 'swing' );
		} );

	}
)( jQuery );